import { render } from "./all-currencies.vue?vue&type=template&id=8b4714f4&scoped=true"
import script from "./all-currencies.vue?vue&type=script&lang=js"
export * from "./all-currencies.vue?vue&type=script&lang=js"

import "./all-currencies.vue?vue&type=style&index=0&id=8b4714f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4714f4"]])

export default __exports__